module.exports = __webpack_public_path__ + "name_tips.png?80f4803fc1564f1337fd4708c57368a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/name_tips.png
// module id = 305
// module chunks = 4